import urlConstants from '~/lib/constants/url.constants';
import api from '~/store/services/api';
import { CacheTag } from '~/store/services/CacheTag';
import { ENUMERATION_CACHE_TIME } from './enumerations';

const invalidatePatientDiagnosesTags = (patientId: string) => [
  {
    id: patientId,
    type: CacheTag.PatientClinicalProfile,
  },
  {
    id: patientId,
    type: CacheTag.PatientDiagnoses,
  },
  {
    id: patientId,
    type: CacheTag.BillingPeriods,
  },
];

export const diagnosesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPatientDiagnoses: build.query<PatientDiagnosis[], string>({
      query: (patientId) =>
        urlConstants.clinical_data.getPatientDiagnoses(patientId),
      providesTags: (result, error, patientId) => [
        { id: patientId, type: CacheTag.PatientDiagnoses },
      ],
    }),
    addPatientDiagnosis: build.mutation<
      { id: string },
      { patientId: string; body: PersistPatientDiagnosisRequest }
    >({
      query: ({ patientId, body }) => ({
        method: 'POST',
        url: urlConstants.clinical_data.addDiagnosis(patientId),
        body,
      }),
      invalidatesTags: (_, __, arg) =>
        invalidatePatientDiagnosesTags(arg.patientId),
    }),
    editPatientDiagnosis: build.mutation<
      { id: string },
      {
        diagnosisId: string;
        patientId: string;
        body: PersistPatientDiagnosisRequest;
      }
    >({
      invalidatesTags: (_, __, arg) =>
        invalidatePatientDiagnosesTags(arg.patientId),
      query: ({ patientId, diagnosisId, body }) => ({
        method: 'PUT',
        url: urlConstants.clinical_data.editDiagnosis(patientId, diagnosisId),
        body,
      }),
    }),
    getDiagnosisCodes: build.query<DiagnosisCode[], string[]>({
      keepUnusedDataFor: ENUMERATION_CACHE_TIME,
      query: (codes) => ({
        params: {
          code: codes.join(','),
        },
        url: urlConstants.clinical_data.getDiagnosisCodes,
      }),
    }),
  }),
});

export const {
  useGetPatientDiagnosesQuery,
  useAddPatientDiagnosisMutation,
  useEditPatientDiagnosisMutation,
  useGetDiagnosisCodesQuery,
} = diagnosesApi;
